import { HTMLAttributes, ReactElement } from 'react'
import { MarginProps, WidthProps } from 'styled-system'

import INTERNALxDiv from 'designSystem/components/internal/elements/INTERNALxDiv'
import { COLOR } from 'designSystem/foundations/constants/color'

type Size = 'sm' | 'md' | 'lg'
type Variant = 'dashed' | 'normal'

type BaseProps = HTMLAttributes<HTMLDivElement> & MarginProps & WidthProps

type Props = {
  size?: Size
  variant?: Variant
} & BaseProps

const _VARIANT = {
  normal: 'normal',
  dashed: 'dashed',
}

const _WIDTH = {
  sm: '1px',
  md: '1.5px',
  lg: '2px',
}

export default function PDSSeparator({
  size = 'sm',
  variant = 'normal',
  ...props
}: Props): ReactElement {
  let width = _WIDTH[size] ?? _WIDTH.sm
  let style = _VARIANT[variant] ?? _VARIANT.normal

  return (
    <INTERNALxDiv
      {...props}
      height={0}
      borderColor={COLOR.content_border}
      borderStyle={style}
      borderWidth={width}
      borderBottom="none"
      borderLeft="none"
      borderRight="none"
    />
  )
}
